export default {_name:'button.simple',module:'Field',view:'Element/Button',options:{variant:'contained',color:'secondary',size:'small',xs:'auto'}}